import fetch from '@/utils/fetch';

const model = {
  state: {
    awardList: [],
    awardListTotal: 0,
    awardFilter: {
      pageNo: 1,
      pageSize: 10,
    },
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { ChiefBenefitManage, basic }, getState }) => ({
    async getAwardListData(params = {}) {
      const newSearchParams = { ...getState().ChiefBenefitManage.awardFilter, ...params };
      const resData = await fetch('/saasmerchant/web/customergroup/award/page', {
        params: newSearchParams,
        type: 'POST',
        useJson: true,
      });
      const { data, total } = resData || {};
      ChiefBenefitManage.setState({
        awardList: data || [],
        awardListTotal: total || [],
        awardFilter: newSearchParams,
      });
    },
    async getChiefActivityList(name) {
      const resData = await fetch('/saasmerchant/web/customergroup/activity/list', {
        params: { pageNum: 1, pageSize: 50, name },
      });
      return resData;
    },
    async getGroupListData(groupName) {
      const resData = await fetch('/saasmerchant/web/customergroup/page', {
        params: { pageNum: 1, pageSize: 50, groupName },
        type: 'POST',
        useJson: true,
      });
      return resData;
    },
    async exportCustomergroupList(searchParams = {}) {
      await fetch('/saasmerchant/web/customergroup/award/export', {
        type: 'POST',
        useJson: true,
        params: searchParams,
      });
      basic.setLogListDot(true);
    },
  }),
};

export default model;
